import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockOptionButton', {
  unblock: 'Desbloquear producto'
});

i18next.addResources('es_CR', 'BlockOptionButton', {
  unblock: 'Desbloquear producto'
});
